import cx from 'classnames';
import React from 'react';

import { Grid } from 'components/Grid/Grid';
import { Image } from 'components/Image/Image';
import type { AppType, Image as ImageType } from 'services/cms/typesUtil';
import { GridContainer } from '../GridContainer/GridContainer';
import styles from './ImageTextModule.module.scss';
import { IMAGE_MODULE_TEST_ID } from './ImageModule.const';

type ImageModuleProps = AppType.Component<{
  image: ImageType;
  isImageTransparent: boolean;
  isImageAlignLeft: boolean;
  imageGridContainerRef: React.Ref<HTMLDivElement>;
  handleImageOnLoad: any;
}>;

export const ImageModule: React.FC<ImageModuleProps> = ({
  image,
  isImageTransparent,
  isImageAlignLeft,
  imageGridContainerRef,
  handleImageOnLoad,
}) => {
  return (
    <GridContainer ref={imageGridContainerRef} onLoad={handleImageOnLoad}>
      {!isImageAlignLeft && (
        <Grid data-testid={IMAGE_MODULE_TEST_ID.right} item xs={false} md={isImageTransparent ? 7 : 4} />
      )}
      <Grid
        className={cx({
          [styles.imageTextModuleImageGridAlignLeft]: isImageAlignLeft,
          [styles.imageTextModuleImageGridAlignRight]: !isImageAlignLeft,
        })}
        item
        xs={12}
        data-testid={isImageTransparent ? IMAGE_MODULE_TEST_ID.gridTransparent : ''}
        md={isImageTransparent ? 5 : 8}
      >
        <Image src={image?.file?.url} role="presentation" className={styles.imageTextModuleImage} />
      </Grid>
      {isImageAlignLeft && <Grid data-testid={IMAGE_MODULE_TEST_ID.left} item xs={false} md={4} />}
    </GridContainer>
  );
};
